if (!customElements.get('custom-dropdown')) {
  class CustomDropdown extends HTMLElement {
    constructor() {
      super();

      this.handleChangeRef = this.handleChange.bind(this);
      this.handleToggleRef = this.handleToggle.bind(this);
      this.handleCloseRef = this.handleClose.bind(this);
      this.setMaxHeightRef = this.setMaxHeight.bind(this);
      this.handleUpdateDropdownToggleHeightRef =
        this.handleChangeDropdownToggleHeight.bind(this);
    }

    handleChangeDropdownToggleHeight(event) {
      if (event.detail.id != this.getAttribute('data-id')) return;

      this.style.setProperty('--offset-top', event.detail.height + 'px');
    }

    dispatchChange(element) {
      if (!element) return;

      document.dispatchEvent(
        new CustomEvent('exo:update-custom-dropdown-value', {
          detail: { id: this.getAttribute('data-id'), html: element.innerHTML },
        }),
      );
    }

    dispatchClose() {
      document.dispatchEvent(
        new CustomEvent('exo:dropdown-close', {
          detail: { id: this.getAttribute('data-id') },
        }),
      );
    }

    handleChange(event) {
      this.dispatchChange(
        event.srcElement.closest('.js-input-wrapper').querySelector('label'),
      );
      this.dispatchClose();
    }

    handleClose(event) {
      if (event.detail.id == this.getAttribute('data-id')) return;
      this.classList.remove('is-open');
      this.dispatchClose();
    }

    handleToggle(event) {
      if (event.detail.id != this.getAttribute('data-id')) return;

      document.dispatchEvent(
        new CustomEvent('exo:close-custom-dropdowns', {
          detail: { id: this.getAttribute('data- id') },
        }),
      );

      this.setMaxHeight();
      this.classList.toggle('is-open', event.detail.force);
    }

    setMaxHeight() {
      const maxHeight = Math.abs(
        window.innerHeight - this.getBoundingClientRect().y - 100,
      );
      this.style.setProperty('--dropdown-max-height', maxHeight + 'px');
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.handleChangeRef);
      document.removeEventListener('exo:toggle-dropdown', this.handleToggleRef);
      document.removeEventListener('click', this.handleCloseRef);
      document.removeEventListener(
        'exo:update-dropdown-toggle-height',
        this.handleUpdateDropdownToggleHeightRef,
      );
      document.removeEventListener(
        'exo:close-custom-dropdowns',
        this.handleCloseRef,
      );
      window.removeEventListener('resize', this.setMaxHeightRef, false);
    }

    connectedCallback() {
      this.addEventListener('change', this.handleChangeRef);
      document.addEventListener('exo:toggle-dropdown', this.handleToggleRef);
      document.addEventListener('click', this.handleCloseRef);
      document.addEventListener(
        'exo:update-dropdown-toggle-height',
        this.handleUpdateDropdownToggleHeightRef,
      );
      document.addEventListener(
        'exo:close-custom-dropdowns',
        this.handleCloseRef,
      );
      window.addEventListener('resize', this.setMaxHeightRef, false);

      this.dispatchChange(
        this.querySelector('input[checked]')
          .closest('.js-input-wrapper')
          ?.querySelector('label'),
      );
    }
  }

  customElements.define('custom-dropdown', CustomDropdown);
}
